// extracted by mini-css-extract-plugin
module.exports = {"root":"quoted-tweet-container_root__pxwIP","article":"quoted-tweet-container_article__eIY5i"};